import { memo, useEffect, useRef } from 'react';
import { useMedia } from '../../../../media.context';
import { VStack } from 'app/pages/request-single-page/components-v4/stack';
import { Dialog } from 'app/pages/request-single-page/components-v4/dialog';
import { Filmstrip, FilmstripThumb } from './desktop-controls.styled';
import { MediaFile } from '../../../media-file/media-file';
import { Controls } from './controls';

export const DesktopControls = memo(() => {
  const { items, previewIndex, openPreview, removeItem, canDelete } =
    useMedia();
  const filmstripRef = useRef<HTMLDivElement>(null);
  const currentItem = items[previewIndex ?? 0];

  useEffect(() => {
    if (!previewIndex || !filmstripRef.current) {
      return;
    }

    const thumb = filmstripRef.current.children[previewIndex] as
      | HTMLElement
      | undefined;

    thumb?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    });
  }, [previewIndex]);

  return (
    <VStack align="center" spacing="m">
      <Dialog.Panel style={{ backgroundColor: 'transparent' }}>
        <Filmstrip ref={filmstripRef}>
          {items.map((item, index) => (
            <FilmstripThumb
              key={item.id}
              $active={index === (previewIndex ?? 0)}
              onClick={() => openPreview(index)}
            >
              <MediaFile file={item} mode="thumbnail" />
            </FilmstripThumb>
          ))}
        </Filmstrip>
      </Dialog.Panel>

      <Controls
        currentFile={currentItem}
        previewIndex={(previewIndex ?? 0) + 1}
        total={items.length}
        canDelete={canDelete}
        onDelete={removeItem}
      />
    </VStack>
  );
});
